import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

function split(ms) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
}

function Tile({ id, label, at, now, accent }) {
  const left = new Date(at).getTime() - now;
  const t = split(left);
  const done = left <= 0;
  return (
    <div className={`border px-4 py-3 min-w-0 ${accent}`} data-testid={`top-badge-countdown-${id}`}>
      <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400">{label}</div>
      {done ? (
        <div className="font-display text-xl text-zinc-300 mt-1" data-testid={`top-badge-countdown-${id}-done`}>Closed</div>
      ) : (
        <div className="flex items-baseline gap-2 mt-1 tabular-nums" data-testid={`top-badge-countdown-${id}-value`} aria-live="off">
          {t.d > 0 && <span className="font-display text-2xl text-white">{t.d}<span className="text-xs text-zinc-400 ml-0.5">d</span></span>}
          <span className="font-display text-2xl text-white">{pad(t.h)}:{pad(t.m)}:{pad(t.s)}</span>
        </div>
      )}
    </div>
  );
}

export default function TopBadgeCountdown({ launchAt, submissionsCloseAt, votingCloseAt }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const beforeLaunch = new Date(launchAt).getTime() > now;
  return (
    <div className="grid gap-3 sm:grid-cols-3" data-testid="top-badge-countdown">
      {beforeLaunch && <Tile id="launch" label="Applications open in" at={launchAt} now={now} accent="border-emerald-400/50 bg-emerald-400/5" />}
      <Tile id="submissions" label="Submissions close in" at={submissionsCloseAt} now={now} accent="border-yellow-400/50 bg-yellow-400/5" />
      <Tile id="voting" label="Voting closes in" at={votingCloseAt} now={now} accent="border-rose-400/50 bg-rose-400/5" />
    </div>
  );
}
